import { render, staticRenderFns } from "./RejectDialog.vue?vue&type=template&id=6419f8ff&scoped=true&"
import script from "./RejectDialog.vue?vue&type=script&lang=js&"
export * from "./RejectDialog.vue?vue&type=script&lang=js&"
import style0 from "./RejectDialog.vue?vue&type=style&index=0&id=6419f8ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6419f8ff",
  null
  
)

export default component.exports